import { s as src, i as page } from './index2.js';
import 'tty';
import 'os';
import 'deepmerge';
import 'axios';
import 'vue';
import { n as normalizeComponent } from './normalize-component.js';

//
var log = src('xpedeo-core:xp-nfc-page');
src.enable(process.env.VUE_APP_DEBUG);
var script = {
  mixins: [page],
  data: function data() {
    return {
      nfcCode: null,
      nfcSupported: true
    };
  },
  mounted: function mounted() {
    log('xpnfcPage mounted', this, this.$router);

    if (this.$xp.device.platform === 'ios') {
      if (!this.$xp.nfc.isEnabled) {
        this.nfcSupported = false;
        return;
      } else {
        log('On iOS, nfc is enabled & supported');
        this.$xp.nfc.scanNdefIos();
      }
    }

    this.$xp.navigation.preventAutoHide();
    this.$xp.navigation.showNav();
    window.localStorage.setItem('nfcPageId', this.pageData.ID);
    var localStorageLangCode = window.localStorage.getItem('nfcLangCode');

    if (!localStorageLangCode) {
      var defaultSettingsLangCode = this.$xp.settings.getValue('content.langCode');
      window.localStorage.setItem('nfcLangCode', defaultSettingsLangCode);
      localStorageLangCode = defaultSettingsLangCode;
    }

    this.$xp.nfc.selectedLangCode = localStorageLangCode;
    this.$xp.nfc.selectedBranchIds = window.localStorage.getItem('nfcSelectedBranchIds') || [];
    this.$xp.nfc.startNfcNavigation();
  },
  methods: {
    clickBranch: function clickBranch(item) {
      if (item.children.length) {
        this.$xp.nfc.goToPage(item.children[0]);
      }
    },
    isInSelectedBranch: function isInSelectedBranch(item) {
      return this.$xp.nfc.selectedBranchIds.includes(item.id) || this.$xp.nfc.selectedBranchIds.includes(item.ancestorId);
    }
  },
  computed: {
    nfcData: function nfcData() {
      return this.pageData.nfc;
    },
    branches: function branches() {
      return this.$xp.nfc.branches;
    },
    languageMenuItems: function languageMenuItems() {
      var items = [];
      this.pageData.LanguageVirtualFolders.forEach(function (item) {
        items.push({
          id: item.ID,
          langName: item.LangName,
          langCode: item.LangCode,
          langId: item.LangID,
          path: item.Path,
          icon: item.Icon
        });
      });
      return items;
    },
    nfcCodeFound: function nfcCodeFound() {
      return this.$xp.nfc.nfcCodeFound;
    },
    selectedLangCode: function selectedLangCode() {
      return this.$xp.nfc.selectedLangCode;
    }
  },
  watch: {
    $route: {
      handler: function handler(newValue, oldValue) {
        log('in xpnfcpage route watcher', newValue, oldValue);

        if (newValue.path === oldValue.path && newValue.query !== null || newValue.query.nfcCode) {
          log('starting navigation');
          this.$xp.nfc.startNfcNavigation();
        }
      }
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.nfcSupported
    ? _c("div", [
        _vm.selectedLangCode == null && _vm.languageMenuItems.length > 1
          ? _c("div", { staticClass: "c-select-language-page" }, [
              _c(
                "ul",
                { staticClass: "c-pages-menu menu" },
                _vm._l(this.languageMenuItems, function(language) {
                  return _c(
                    "li",
                    {
                      key: language.id,
                      staticClass:
                        "c-select-language-page__menu-item menu__item link"
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "c-select-language-page__link",
                          attrs: { href: "#", role: "link" },
                          on: {
                            click: function($event) {
                              $event.preventDefault();
                              return _vm.$xp.nfc.setAppLang(language)
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "c-select-language-page__name" },
                            [_vm._v(_vm._s(language.langName))]
                          ),
                          _vm._v(" "),
                          _c("img", {
                            staticClass: "c-select-language-page__icon",
                            attrs: {
                              src: language.icon,
                              alt: language.langName,
                              "aria-hidden": "true"
                            }
                          })
                        ]
                      )
                    ]
                  )
                }),
                0
              )
            ])
          : _vm.nfcCodeFound
          ? _c("div", { staticClass: "c-nfc-page" }, [
              _c(
                "ul",
                { staticClass: "c-pages-menu" },
                _vm._l(_vm.branches, function(item) {
                  return _c(
                    "li",
                    { key: item.id, staticClass: "c-nfc-page__item" },
                    [
                      item.children.length == 0
                        ? _c(
                            "a",
                            {
                              staticClass: "c-nfc-page__link",
                              attrs: { href: "#", role: "link" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault();
                                  return _vm.$xp.nfc.goToPage(item)
                                }
                              }
                            },
                            [
                              _c("div", { staticClass: "c-nfc-page__title" }, [
                                _vm._v(_vm._s(item.title))
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      item.children.length
                        ? _c(
                            "a",
                            {
                              class:
                                (_vm.isInSelectedBranch(item)
                                  ? "selected "
                                  : "") + "c-nfc-page__link",
                              attrs: { href: "#", role: "link" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault();
                                  return _vm.clickBranch(item)
                                }
                              }
                            },
                            [
                              _c("div", { staticClass: "c-nfc-page__title" }, [
                                _vm._v(_vm._s(item.title))
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      item.children.length
                        ? _c(
                            "ul",
                            { staticClass: "c-pages-menu menu" },
                            _vm._l(item.children, function(subitem) {
                              return _c(
                                "li",
                                {
                                  key: subitem.id,
                                  staticClass: "c-nfc-page__item"
                                },
                                [
                                  subitem.children.length == 0
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "c-nfc-page__link",
                                          attrs: { href: "#", role: "link" },
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault();
                                              return _vm.$xp.nfc.goToPage(
                                                subitem
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              class:
                                                (_vm.isInSelectedBranch(item)
                                                  ? "selected "
                                                  : "") + "c-nfc-page__title"
                                            },
                                            [_vm._v(_vm._s(subitem.title))]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  subitem.children.length
                                    ? _c(
                                        "div",
                                        { staticClass: "c-nfc-page__title" },
                                        [_vm._v(_vm._s(subitem.title))]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  subitem.children.length
                                    ? _c(
                                        "ul",
                                        { staticClass: "c-pages-menu" },
                                        _vm._l(subitem.children, function(
                                          subsubitem
                                        ) {
                                          return _c(
                                            "li",
                                            {
                                              key: subsubitem.id,
                                              staticClass: "c-nfc-page__item"
                                            },
                                            [
                                              subsubitem.children.length == 0
                                                ? _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "c-nfc-page__link",
                                                      attrs: {
                                                        href: "#",
                                                        role: "link"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          $event.preventDefault();
                                                          return _vm.$xp.nfc.goToPage(
                                                            subsubitem
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          class:
                                                            (_vm.isInSelectedBranch(
                                                              item
                                                            )
                                                              ? "selected "
                                                              : "") +
                                                            "c-nfc-page__title"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              subsubitem.title
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              subsubitem.children.length
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "c-nfc-page__title"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(subsubitem.title)
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          )
                                        }),
                                        0
                                      )
                                    : _vm._e()
                                ]
                              )
                            }),
                            0
                          )
                        : _vm._e()
                    ]
                  )
                }),
                0
              )
            ])
          : _vm.$route.query.nfcCode
          ? _c(
              "div",
              { staticClass: "c-nfc-page" },
              [
                _c("xp-section", { staticClass: "c-nfc-page__not-found" }, [
                  _c("div", { staticClass: "js-entry o-entry c-text-entry" }, [
                    _c("div", { staticClass: "c-text-entry__content" }, [
                      _vm._v(
                        "\n                  Dem NFC code " +
                          _vm._s(_vm.$route.query.nfcCode) +
                          " ist kein Inhalt zugeordnet.\n              "
                      )
                    ])
                  ])
                ])
              ],
              1
            )
          : _c(
              "div",
              { staticClass: "c-nfc-page" },
              [
                _vm._l(_vm.pageData.Sections, function(section) {
                  return _c(
                    "xp-section",
                    { key: section.ID },
                    _vm._l(section.entries, function(entry) {
                      return _c("dynamic-entry", {
                        key: entry.ID,
                        attrs: { entryData: entry, id: "entry-" + entry.ID }
                      })
                    }),
                    1
                  )
                }),
                _vm._v(" "),
                _vm.$xp.device.platform === "browser" &&
                _vm.pageData.Settings.nfcIosBrowserHint &&
                _vm.$xp.device.isIPhoneOrPad
                  ? _c(
                      "div",
                      { staticClass: "c-nfc-page__nfc-ios-browser-hint" },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.pageData.Settings.nfcIosBrowserHint) +
                            "\n      "
                        )
                      ]
                    )
                  : _vm._e()
              ],
              2
            )
      ])
    : _c("div", { staticClass: "c-nfc-page__error-message" }, [
        _vm._v("\n  " + _vm._s(_vm.$t("global.nfcNotAvailable")) + "\n")
      ])
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
//# sourceMappingURL=XpNfcPage.js.map
